const ALL_DISCONNECTION_BEHAVIORS = ['immediate', 'delayed'];
export function isDisconnectionBehavior(value) {
    return typeof value === 'string' && ALL_DISCONNECTION_BEHAVIORS.includes(value);
}
